import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadBranding, getBranding } from './config/branding';
import { initI18n } from './i18n';
// Edition theme overrides — scoped to body.edition-<id>, inert unless that
// class is set, so Sense is unaffected. Loaded statically for reliable order.
import './styles/dievo.css';
import './styles/dievo-overrides.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Load edition branding (theme + features) before first render so colors,
// title and feature gates are correct from the start. Falls back to Sense
// defaults if the backend is unreachable.
loadBranding().finally(() => {
  // Branding first: the edition decides the default language when the visitor
  // has not picked one and the session has not answered yet.
  initI18n(getBranding().edition);
  root.render(
    <App />
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
